import { SessionCamTracking } from '@mgmresorts/wcl-utils';
import React, { useContext, useCallback } from 'react';
import { Button } from '../Button/Button.es.js';
import '../Button/FixedButton.es.js';
import '../Button/Button.styles.es.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.es.js';
import { Modal } from '../Modal/Modal.es.js';
import '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import '../Modal/ModalContainer/ModalContainer.es.js';
import '../Modal/ModalContent/ModalContent.es.js';
import '../RoomBookingNavigation/RoomBookingNavigation.es.js';
import '../RoomBookingNavigation/elements/CenteredNavTitle.es.js';
import '../RoomBookingNavigation/elements/CenterPropertyLogo.es.js';
import '../RoomBookingNavigation/elements/LeftBackButton.es.js';
import '../RoomBookingNavigation/elements/LeftCloseButton.es.js';
import '../DropdownMenu/MenuTrigger/MenuTrigger.es.js';
import '../DropdownMenu/MenuTrigger/MenuContent.styles.es.js';
import '../DropdownMenu/MenuButton/MenuButton.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenu.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenuLoginForm.es.js';
import '../../../../node_modules/@babel/runtime/helpers/typeof.es.js';
import '../Box/Box.es.js';
import '../Box/FlexColumn.es.js';
import '../Box/FlexRow.es.js';
import '../Box/GridColumn.es.js';
import '../Box/GridRow.es.js';
import '../Text/Text.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenuSignedOut.styles.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenuSignedIn.es.js';
import '../MlifeMenu/MlifeMenu/TierProgressBar.es.js';
import '../MlifeMenu/MlifeMenuTrigger/MlifeMenuButton.es.js';
import '../MlifeMenu/MlifeMenuTrigger/MlifeMenuTrigger.es.js';
import '../Icons/icons/createIcon.es.js';
import '../Icons/icons/AdultsOnlyIcon.es.js';
import '../Icons/icons/AttractionsIcon.es.js';
import '../Icons/icons/BackIcon.es.js';
import '../Icons/icons/BarberIcon.es.js';
import '../Icons/icons/BedIcon.es.js';
import '../Icons/icons/BestRateGuaranteedIcon.es.js';
import '../Icons/icons/CalendarIcon.es.js';
import '../Icons/icons/CartIcon.es.js';
import '../Icons/icons/ChairIcon.es.js';
import '../Icons/icons/CheckIcon.es.js';
import '../Icons/icons/CirqueIcon.es.js';
import '../Icons/icons/CloseCircleFilledIcon.es.js';
import '../Icons/icons/CloseIcon.es.js';
import '../Icons/icons/ComedyIcon.es.js';
import '../Icons/icons/ConcertsIcon.es.js';
import '../Icons/icons/CouchIcon.es.js';
import '../Icons/icons/CreditCardIcon.es.js';
import '../Icons/icons/CulinaryIcon.es.js';
import '../Icons/icons/DesertViewIcon.es.js';
import '../Icons/icons/DrinkIcon.es.js';
import '../Icons/icons/DropdownArrowIcon.es.js';
import '../Icons/icons/EnlargeIcon.es.js';
import '../Icons/icons/FanIcon.es.js';
import '../Icons/icons/FilterIcon.es.js';
import '../Icons/icons/ForwardIcon.es.js';
import '../Icons/icons/FreeCancellationIcon.es.js';
import '../Icons/icons/GridDisabledIcon.es.js';
import '../Icons/icons/GridEnabledIcon.es.js';
import '../Icons/icons/GuestsIcon.es.js';
import '../Icons/icons/HeartIcon.es.js';
import '../Icons/icons/HidePasswordIcon.es.js';
import '../Icons/icons/InformationCircleIcon.es.js';
import '../Icons/icons/ListViewIcon.es.js';
import '../Icons/icons/LockFilledIcon.es.js';
import '../Icons/icons/LockOutlineIcon.es.js';
import '../Icons/icons/LongArrowIcon.es.js';
import '../Icons/icons/LoungeChairIcon.es.js';
import '../Icons/icons/MagicIcon.es.js';
import '../Icons/icons/MattressIcon.es.js';
import '../Icons/icons/MenuIcon.es.js';
import '../Icons/icons/MinibarIcon.es.js';
import '../Icons/icons/MinusCircleIcon.es.js';
import '../Icons/icons/MinusIcon.es.js';
import '../Icons/icons/MlifeIcon.es.js';
import '../Icons/icons/PanoramicViewIcon.es.js';
import '../Icons/icons/PasswordXIcon.es.js';
import '../Icons/icons/PhoneIcon.es.js';
import '../Icons/icons/PlusCircleIcon.es.js';
import '../Icons/icons/PlusIcon.es.js';
import '../Icons/icons/PoolIcon.es.js';
import '../Icons/icons/ProfileIcon.es.js';
import '../Icons/icons/RefreshIcon.es.js';
import '../Icons/icons/SafeIcon.es.js';
import '../Icons/icons/SearchIcon.es.js';
import '../Icons/icons/ShowPasswordIcon.es.js';
import '../Icons/icons/ShowerIcon.es.js';
import '../Icons/icons/SortIcon.es.js';
import '../Icons/icons/SpaRocksIcon.es.js';
import '../Icons/icons/SpecialEventsIcon.es.js';
import '../Icons/icons/Spinner.es.js';
import '../Icons/icons/SportsIcon.es.js';
import '../Icons/icons/SpotCalendarIcon.es.js';
import '../Icons/icons/StripViewIcon.es.js';
import '../Icons/icons/TvIcon.es.js';
import '../Icons/icons/UmbrellaIcon.es.js';
import '../Icons/icons/WarningCircleIcon.es.js';
import '../Icons/icons/WarningTriangleFilledIcon.es.js';
import '../Icons/icons/WarningTriangleIcon.es.js';
import '../Icons/icons/WiFiIcon.es.js';
import '../Icons/icons/BestRateIcon.es.js';
import '../Icons/icons/FiveDiamondAwardIcon.es.js';
import '../Icons/icons/ForbesTravelGuideIcon.es.js';
import '../Icons/icons/AriaStackedIcon.es.js';
import '../Icons/icons/BeauRivageIcon.es.js';
import '../Icons/icons/BellagioIcon.es.js';
import '../Icons/icons/BellagioInternationalIcon.es.js';
import '../Icons/icons/BorgataIcon.es.js';
import '../Icons/icons/CircusCircusIcon.es.js';
import '../Icons/icons/DelanoIcon.es.js';
import '../Icons/icons/ExcaliburIcon.es.js';
import '../Icons/icons/GoldStrikeIcon.es.js';
import '../Icons/icons/LuxorIcon.es.js';
import '../Icons/icons/MandalyBayIcon.es.js';
import '../Icons/icons/MGMChinaIcon.es.js';
import '../Icons/icons/MGMDiayutaiIcon.es.js';
import '../Icons/icons/MGMGrandDetroitIcon.es.js';
import '../Icons/icons/MGMGrandIcon.es.js';
import '../Icons/icons/MGMGrandSanyaIcon.es.js';
import '../Icons/icons/MGMMacauIcon.es.js';
import '../Icons/icons/MGMNationalHarborIcon.es.js';
import '../Icons/icons/MGMResortIcon.es.js';
import '../Icons/icons/MGMSpringfieldIcon.es.js';
import '../Icons/icons/MirageIcon.es.js';
import '../Icons/icons/MyVegasIcon.es.js';
import '../Icons/icons/NYNYIcon.es.js';
import '../Icons/icons/ParkMGMIcon.es.js';
import '../Icons/icons/SignatureIcon.es.js';
import '../Icons/icons/VdaraIcon.es.js';
import '../Icons/icons/FacebookIcon.es.js';
import '../Icons/icons/TwitterIcon.es.js';
import '../Icons/icons/YouTubeIcon.es.js';
import '../Icons/icons/PinterestIcon.es.js';
import '../Icons/icons/InstagramIcon.es.js';
import '../Icons/icons/PlayMGMIcon.es.js';
import '../Icons/icons/MGMGRIResortIcon.es.js';
import { ViewportContext } from '../ViewportContext/ViewportContext.es.js';
import '@mgmresorts/wcl-styled';
import '../MlifeMenu/MlifeMenuTrigger/MobileModelHeader.styles.es.js';
import '../RoomBookingNavigation/elements/ShoppingCart.es.js';
import '../Modal/ModalContent/ModalContent.styles.es.js';
import '../Modal/ModalContent/BottomModalContent/BottomModalContent.styles.es.js';
import '../Modal/ModalContent/CenteredModalContent/CenteredModalContent.es.js';
import '../Modal/ModalContent/FullscreenModalContent/FullscreenModalContent.es.js';
import { StyledDesktopTitle, StyledDesktopDescription, StyledMobileDescription, StyledMobilePrimaryButtonWrapper, StyledModalContent } from './ConfirmModal.styles.es.js';

/**
 * Mount this component when you need to show a modal with confirmation message.
 *
 * Pass `props.onSubmit` function in order to retrieve the modal result
 * (type of the button that was used to close the modal).
 *
 * Then, pass `open: false`, and only after `props.onCloseEnd` is called, unmount it.
 *
 * Renders a <ConfirmModal /> component
 * @param {boolean} open - an optional param - open confirmModal by default
 * @param {string} title - an optional param - set the title on the confirmModal
 * @param {string} description - an optional param - set the description on the confirmModal
 * @param {object} primaryAction - an optional param - set the primaryLabel on the confirmModal
 * @param {object} secondaryAction - an optional param - set the secondaryLabel on the confirmModal
 * @param {boolean} dismissible - an optional param - close modal on clicking outside
 * @param {void} onDismiss - an optional param - call function on clicking modal outside
 * @param {void} onSubmit - an optional param - call submit function
 * @param {void} onCloseEnd - an optional param - will be called once modal close animation ends
 **/

function ConfirmModal(props) {
  var _props$open = props.open,
      open = _props$open === void 0 ? true : _props$open,
      title = props.title,
      description = props.description,
      _props$primaryAction = props.primaryAction,
      primaryAction = _props$primaryAction === void 0 ? {
    label: 'Close'
  } : _props$primaryAction,
      secondaryAction = props.secondaryAction,
      _props$dismissible = props.dismissible,
      dismissible = _props$dismissible === void 0 ? true : _props$dismissible,
      onDismiss = props.onDismiss,
      onSubmit = props.onSubmit,
      onCloseEnd = props.onCloseEnd;
  var viewport = useContext(ViewportContext);
  var handleSubmit = useCallback(function (result) {
    if (onSubmit) {
      onSubmit(result);
    }
  }, [onSubmit]);
  var handlePrimaryActionClick = useCallback(function () {
    handleSubmit('primary');
  }, [handleSubmit]);
  var handleSecondaryActionClick = useCallback(function () {
    handleSubmit('secondary');
  }, [handleSubmit]);
  var content = viewport.minMd ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SessionCamTracking, null, /*#__PURE__*/React.createElement(StyledDesktopTitle, {
    as: "h1"
  }, title), description && /*#__PURE__*/React.createElement(StyledDesktopDescription, null, description)), /*#__PURE__*/React.createElement(ButtonGroup, {
    layout: "blocks",
    spacing: "large"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "large",
    fullWidth: true,
    label: primaryAction.label,
    onClick: handlePrimaryActionClick
  }), secondaryAction && /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "large",
    fullWidth: true,
    label: secondaryAction.label,
    onClick: handleSecondaryActionClick
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SessionCamTracking, null, description && /*#__PURE__*/React.createElement(StyledMobileDescription, null, description)), secondaryAction && /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    shape: "text",
    size: "small",
    fullWidth: true,
    label: secondaryAction.label,
    onClick: handleSecondaryActionClick
  }), /*#__PURE__*/React.createElement(StyledMobilePrimaryButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "fixedSmall",
    shape: "fixed-pill",
    noBorderRadius: true,
    fullWidth: true,
    label: primaryAction.label,
    onClick: handlePrimaryActionClick
  })));
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    desktopLayout: "centered",
    mobileLayout: "bottom",
    title: title,
    closeButton: dismissible,
    closeOnBackdropClick: dismissible,
    closeOnEsc: dismissible,
    onClose: onDismiss,
    onHideTransitionEnd: onCloseEnd,
    "data-testid": ConfirmModal.selector()
  }, /*#__PURE__*/React.createElement(StyledModalContent, null, content));
}

ConfirmModal.selector = function () {
  return 'ConfirmModal';
};

export { ConfirmModal };
